import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Job';

const routes = [
    {
        matchRegex: '/Job',
        name: getRouteName(MODULE_NAME, 'Listing'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SECTION
        ],
        image: PreviewDListlImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_TOGGLE_VIEW', label: 'Before Toogle View' },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_BATCHING',
                    label: 'Before Toogle Batching',
                },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_TABLE_SETTING',
                    label: 'Before Toogle Table Setting',
                },
            ],
        },
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'section-search-job-filter', label: 'Advanced Search Filter' },
            ],
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'job-table', label: 'Job List' },
            ],
        },
    },
    {
        matchRegex: '/Job/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_V_TABLE_COLUMN
        ],
        image: PreviewDetailImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'log-quote-modal-before-footer', label: 'Modal "Log quote" - before footer' },
                { key: 'wrapper-visit-engineer', label: 'Tab Visit - Engineer input section' },
                { key: 'wrapper-job-detail-engineer', label: 'Job Detail - Engineer input section' },
                { key: 'wrapper-tab-cost', label: 'Wrapper Section Cost Tab' },
                { key: 'config-number-of-engineers', label: 'Config Number of Engineers Visit' },
                { key: 'job-cost-material', label: 'Job Cost - Material Line' },
            ],
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'invoice-list', label: 'Invoice List' },
                { key: 'purchase-orders-table', label: 'Supplier Purchase Order Table' },
                { key: 'subcontractor-po-list', label: 'Subcontractor PO List' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_CHECK_AVAILABLE_QUANTITY', label: 'Check Available Quantity' },
                { key: 'MARKETPLACE_EVENT_ALLOCATE', label: 'Checking Button Allocate in tab visit' },
                {
                    key: 'MARKETPLACE_EVENT_AFTER_SAVE_COST_LINE_SUCCESS',
                    label: 'After save cost line success'
                },
                {
                    key: 'MARKETPLACE_EVENT_AFTER_DELETE_COST_LINE_SUCCESS',
                    label: 'After delete cost line success'
                },
                { key: 'job-cost-material-validator-available-quantity', label: 'Check available quantity in job cost material' },
                { key: 'MARKETPLACE_EVENT_STOCK_REQUEST_CHECK_VAN_LINKED', label: 'Stock Request Check Van Linked' },
                { key: 'MARKETPLACE_EVENT_GET_APP_ID_AI_SUGGESTION', label: 'Get AppId AI Suggestion' },
            ],
        },
        replaceElements: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'quantity-cost-elements', label: 'Material Cost Quantity Elements' },
            ],
        },
    },
    {
        matchRegex: '/Job/ServiceLetterIndex',
        name: getRouteName(MODULE_NAME, 'Service Job Letters'),
        slots: [
            SLOT_KEY.SLOT_V_ADDITION_MENU,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'service-letter-table', label: 'Service Job Letters Table' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_TABLE_SETTING',
                    label: 'Before Toogle Table Setting',
                },
                { key: 'MARKETPLACE_EVENT_FETCH_LIST_ENGINEERS_PREDICT_SUCCESS', label: 'Fetch List Engineers Predict Success' },
                { key: 'MARKETPLACE_EVENT_SAVE_AUDIT_ENGINEERS', label: 'Save Audit Engineers' },
            ],
        }
    },
]

export default routes;